import * as React from 'react';
import type { Room } from 'livekit-client';
import { RemoteAudioWatchdog, type RemoteAudioWatchdogOptions } from '@/lib/remote-audio-watchdog';

/**
 * Monta o {@link RemoteAudioWatchdog} enquanto o `room` existir. Detecta e re-inscreve
 * áudio remoto que parou de chegar ("não ouço o fulano") — ver remote-audio-watchdog.ts.
 */
export function useRemoteAudioWatchdog(
  room: Room | undefined,
  options?: Pick<RemoteAudioWatchdogOptions, 'onRecover'>,
) {
  const onRecoverRef = React.useRef(options?.onRecover);
  onRecoverRef.current = options?.onRecover;

  React.useEffect(() => {
    if (!room) return;
    const watchdog = new RemoteAudioWatchdog(room, {
      onRecover: (info) => onRecoverRef.current?.(info),
    });
    watchdog.start();
    return () => watchdog.stop();
  }, [room]);
}
